import moment from "moment";
import {DELIVERY_PROVIDER_DEADLINE_HOUR, MINIMUM_ORDER_NOTICE_HOURS} from "./consts.jsx";

export const getDateTimeFilterTitle = dateTimeFilter => {
    if (!dateTimeFilter || !dateTimeFilter?.eventDate) {
        return null;
    }

    const parts = [];

    parts.push(moment(dateTimeFilter.eventDate).format("DD/MM/YYYY"));

    if (dateTimeFilter.maxTime) {
        parts.push(moment(dateTimeFilter.maxTime).format("HH:mm"));
    }

    return parts.length > 0 ? parts.join(" - ") : null;
};

// Validate minimum notice (3 hours) - only for today
export const validateMinimumNotice = (selectedDate, selectedTime) => {
    if (!selectedDate || !selectedTime) {
        return null;
    }

    // Only validate if the selected date is TODAY
    const isToday = moment(selectedDate).isSame(moment(), "day");
    if (!isToday) {
        return null; // No validation needed for future dates
    }

    const selectedDateTime = moment(selectedDate)
        .hour(selectedTime.hour())
        .minute(selectedTime.minute())
        .second(0)
        .millisecond(0);

    const now = moment().second(0).millisecond(0);
    const minimumNoticeTime = now.clone().add(MINIMUM_ORDER_NOTICE_HOURS, "hours");

    // Allow exactly 3 hours or more
    if (selectedDateTime.isBefore(minimumNoticeTime)) {
        return `לא ניתן להזמין מוצר בהתראה של פחות מ- ${MINIMUM_ORDER_NOTICE_HOURS} שעות`;
    }

    return null;
};

export const validateDateTimeFilter = (eventDate, maxTime) => {
    const errors = {};

    if (!eventDate) {
        errors.eventDate = "יש לבחור תאריך";
    }

    // Time is optional, so only validate when both exist
    if (eventDate && maxTime) {
        const noticeError = validateMinimumNotice(eventDate, maxTime);
        if (noticeError) {
            errors.maxTime = noticeError;
        }
    }

    return errors;
};
